<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
      <div class="form-group row">
        <label :for="safeId('title')" class="col-sm-4 col-form-label">Title</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('title')" v-model.lazy="title">
        </div>
      </div>

      <div class="form-group row">
        <label :for="safeId('record1')" class="col-sm-4 col-form-label">Gold</label>
        <div class="col-sm-8">
          <record-select :dataset-id="datasetId" v-model="recordId1"></record-select>
        </div>
      </div>
      <div class="form-group row">
        <label :for="safeId('record2')" class="col-sm-4 col-form-label">Silver</label>
        <div class="col-sm-8">
          <record-select :dataset-id="datasetId" v-model="recordId2"></record-select>
        </div>
      </div>
      <div class="form-group row">
        <label :for="safeId('record3')" class="col-sm-4 col-form-label">Bronze</label>
        <div class="col-sm-8">
          <record-select :dataset-id="datasetId" v-model="recordId3"></record-select>
        </div>
      </div>
    </window-tab>
    <window-tab title="Data" icon="database">
      <div class="form-group row">
        <label :for="safeId('datasetId')" class="col-sm-4 col-form-label">Dataset</label>
        <div class="col-sm-8">
          <dataset-select :id="safeId('datasetId')" v-model="datasetId"></dataset-select>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-4 col-form-label">Fields</label>
        <div class="col-sm-8">
          <input type="text" readonly class="form-control-plaintext" :value="fields">
        </div>
      </div>
      <div class="form-group row">
        <label :for="safeId('patternBibNumber')" class="col-sm-4 col-form-label">Bib number</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternBibNumber')" v-model.lazy="patternBibNumber">
        </div>
      </div>
      <div class="form-group row">
        <label :for="safeId('patternName')" class="col-sm-4 col-form-label">Name</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternName')" v-model.lazy="patternName">
        </div>
      </div>
      <div class="form-group row">
        <label :for="safeId('patternCountry')" class="col-sm-4 col-form-label">Country</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternCountry')" v-model.lazy="patternCountry">
        </div>
      </div>
      <div class="form-group row">
        <label :for="safeId('patternRank')" class="col-sm-4 col-form-label">Rank</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternRank')" v-model.lazy="patternRank">
        </div>
      </div>
      <div class="form-group row">
        <label :for="safeId('patternScore')" class="col-sm-4 col-form-label">Score</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternScore')" v-model.lazy="patternScore">
        </div>
      </div>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId"></template-settings>
    </window-tab>
  </window>
</template>

<script>
  import { templateMixin } from '@/mixins'
  import * as action from '@/store/action-types'
  import { mapOverlayData, mapRecord, mapTemplateData } from '@/utils'

  export default {
    name: 'uiaa-victory-ceremony-athlete',
    mixins: [templateMixin],
    computed: {
      ...mapOverlayData(['title']),
      ...mapTemplateData(['datasetId', 'recordId1', 'recordId2', 'recordId3']),
      records () {
        return [
          mapRecord(this.$store.getters.datasetRecord(this.datasetId, this.recordId1), this.patterns),
          mapRecord(this.$store.getters.datasetRecord(this.datasetId, this.recordId2), this.patterns),
          mapRecord(this.$store.getters.datasetRecord(this.datasetId, this.recordId3), this.patterns)
        ]
      },
      fields () {
        return this.$store.getters.datasetColumns(this.datasetId)
      },

      ...mapTemplateData({
        /* eslint-disable no-template-curly-in-string */
        'patternBibNumber': {default: '${BIB}'},
        'patternRank': {default: '${RANK}'},
        'patternName': {default: '${LAST NAME} ${FIRST NAME}'},
        'patternCountry': {default: '${COUNTRY}'},
        'patternScore': {default: '${SCORE}${Route 1}'}
        /* eslint-enable no-template-curly-in-string */
      }),

      patterns () {
        return {
          'bibNumber': this.patternBibNumber,
          'rank': this.patternRank,
          'name': this.patternName,
          'country': this.patternCountry,
          'score': this.patternScore
        }
      }
    },
    watch: {
      records: function (val) {
        this.$store.dispatch(action.TEMPLATE_OVERLAY_DATA, {
          templateId: this.templateId,
          data: {records: val}
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/templates/uiaa-victory-ceremony-group.vue